import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import React, { Suspense, useState, useEffect } from "react";
import { useIsMobile } from "../../../hooks/useIsMobile";
import headerLinks from "./headerLinks";
import JoinWaitlistConfirmationHeader from "./JoinWaitlistConfirmationHeader";
import i18next from "i18next";
import ReservationConfirmationHeader from "./ReservationConfirmationHeader";
var BrandDesktopHeaderContent = /*#__PURE__*/React.lazy(function () {
  return import("./BrandDesktopHeaderContent");
});
var MobileHeader = /*#__PURE__*/React.lazy(function () {
  return import("./MobileHeader");
});
var LocationSelectorComp = /*#__PURE__*/React.lazy(function () {
  return import("../../OrderSettings/components/LocationSelection");
});
var JoinWaitListHeader = /*#__PURE__*/React.lazy(function () {
  return import("./JoinWaitListHeader");
});
var WaitListVisibilityHeader = /*#__PURE__*/React.lazy(function () {
  return import("./WaitlistVisibilityHeader");
});
var MobilePayHeader = /*#__PURE__*/React.lazy(function () {
  return import("./MobilePayHeader");
});

var Header = function Header(_ref) {
  var _store$styleCode, _store$menuList, _store$menuList$menuL, _store$menuList3, _store$menuList3$orde, _store$menuList3$orde2, _store$restaurant, _store$joinWaitlist;

  var openCartSlider = _ref.openCartSlider,
      hideLinks = _ref.hideLinks,
      isDineInLinks = _ref.isDineInLinks,
      isDineInConfirmationPage = _ref.isDineInConfirmationPage,
      showJoinWaitListHeader = _ref.showJoinWaitListHeader,
      showJoinWaitListConfirmationHeader = _ref.showJoinWaitListConfirmationHeader,
      showWaitListVisibilityHeader = _ref.showWaitListVisibilityHeader,
      showMobilePayHeader = _ref.showMobilePayHeader,
      isDeliveryPage = _ref.isDeliveryPage,
      showConfirmReservationHeader = _ref.showConfirmReservationHeader,
      waitListCTA = _ref.waitListCTA,
      waitListCTALinks = _ref.waitListCTALinks;
  var store = useStore();
  var styleCode = store === null || store === void 0 ? void 0 : (_store$styleCode = store.styleCode) === null || _store$styleCode === void 0 ? void 0 : _store$styleCode.toUpperCase();
  var isMobile = useIsMobile();
  var links = headerLinks[styleCode];
  var defaultCategoryCode = store === null || store === void 0 ? void 0 : (_store$menuList = store.menuList) === null || _store$menuList === void 0 ? void 0 : (_store$menuList$menuL = _store$menuList.menuListModel) === null || _store$menuList$menuL === void 0 ? void 0 : _store$menuList$menuL.defaultCategoryCode;

  var _useState = useState(""),
      waitlistId = _useState[0],
      setWaitlistId = _useState[1];

  useEffect(function () {
    function getWaitlistId() {
      return _getWaitlistId.apply(this, arguments);
    }

    function _getWaitlistId() {
      _getWaitlistId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _store$menuList2;

        var waitlistId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store === null || store === void 0 ? void 0 : (_store$menuList2 = store.menuList) === null || _store$menuList2 === void 0 ? void 0 : _store$menuList2.getWaitlistId();

              case 2:
                waitlistId = _context.sent;
                setWaitlistId(waitlistId);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getWaitlistId.apply(this, arguments);
    }

    getWaitlistId();
  });
  var restId = store === null || store === void 0 ? void 0 : (_store$menuList3 = store.menuList) === null || _store$menuList3 === void 0 ? void 0 : (_store$menuList3$orde = _store$menuList3.orderSettingsModel) === null || _store$menuList3$orde === void 0 ? void 0 : (_store$menuList3$orde2 = _store$menuList3$orde.currentRestaurant) === null || _store$menuList3$orde2 === void 0 ? void 0 : _store$menuList3$orde2.restaurantInfo;
  var waitlistFlowEnabled = store === null || store === void 0 ? void 0 : (_store$restaurant = store.restaurant) === null || _store$restaurant === void 0 ? void 0 : _store$restaurant.isLocationWaitListOn;
  var joinWaitlistModel = store === null || store === void 0 ? void 0 : (_store$joinWaitlist = store.joinWaitlist) === null || _store$joinWaitlist === void 0 ? void 0 : _store$joinWaitlist.joinWaitlistModel;
  var isOnWaitlist = !!(joinWaitlistModel !== null && joinWaitlistModel !== void 0 && joinWaitlistModel.waitListId) || waitlistId;
  var waitListCTALink = i18next.t(isOnWaitlist ? "link.waitlistjoined.confirmation" : "link.joinwaitlist.desktop", {
    defaultValue: isOnWaitlist ? "/wait-list/confirmation" : "/home?waitlist=true"
  });
  var waitListCTALabel = waitlistFlowEnabled ? i18next.t("label.header.waitlist.cta", {
    defaultValue: "WAITLIST"
  }) : "";
  var waitListMobileCTALinks = i18next.t(isOnWaitlist ? "link.waitlistjoined.confirmation" : "link.joinwaitlist.mobile", {
    defaultValue: isOnWaitlist ? "/wait-list/confirmation" : "/locations/webahead/m-join-wait-list?restID=".concat(restId),
    interpolation: {
      prefix: "${",
      suffix: "}"
    },
    0: restId
  });
  var menuPageLink = defaultCategoryCode ? "/menu/".concat(defaultCategoryCode) : "/menu";

  if (showMobilePayHeader) {
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(MobilePayHeader, {})
    });
  }

  if (showWaitListVisibilityHeader) {
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(WaitListVisibilityHeader, {})
    });
  }

  if (showJoinWaitListHeader) {
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(JoinWaitListHeader, {})
    });
  }

  if (showConfirmReservationHeader) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: isMobile ? /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(ReservationConfirmationHeader, {})
      }) : /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(JoinWaitListHeader, {})
      })
    });
  }

  if (showJoinWaitListConfirmationHeader) {
    return /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(JoinWaitlistConfirmationHeader, {})
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isMobile ? /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(MobileHeader, {
        links: links,
        brand: styleCode,
        openCartSlider: openCartSlider,
        hideLinks: hideLinks,
        isDineInLinks: isDineInLinks,
        isDineInConfirmationPage: isDineInConfirmationPage,
        menuPageUrl: menuPageLink,
        isDeliveryPage: isDeliveryPage,
        waitListCTA: waitListCTALabel,
        waitListCTALinks: waitListMobileCTALinks
      })
    }) : /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(BrandDesktopHeaderContent, {
        brand: styleCode,
        openCartSlider: openCartSlider,
        hideLinks: hideLinks,
        isDineInLinks: isDineInLinks,
        isDineInConfirmationPage: isDineInConfirmationPage,
        menuPageUrl: menuPageLink,
        waitListCTA: waitListCTALabel,
        waitListCTALinks: waitListCTALink
      })
    }), /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      children: /*#__PURE__*/_jsx(LocationSelectorComp, {})
    })]
  });
};

export default observer(Header);